/* eslint-disable promise/avoid-new, no-new */
import Compressor from 'compressorjs';

import processFileBlob from './processFileBlob';

export type ResizerOptions = {
  maxImageSize?: number;
  maxQuality?: number;
};
export const DEFAULT_MAX_IMAGE_SIZE = 2500;
export const DEFAULT_MAX_QUALITY = 0.7;

/**
 * Compresses an image with the provided parameters, and returns the base64 implementation
 *
 * @param image - The image file to compress
 * @param options - The options that will be provided to the compressor
 */
const compressImage = (
  image: File,
  {
    maxImageSize = DEFAULT_MAX_IMAGE_SIZE,
    maxQuality = DEFAULT_MAX_QUALITY,
  }: ResizerOptions = {},
): Promise<string> =>
  new Promise<string>((resolve) => {
    new Compressor(image, {
      quality: maxQuality,
      maxWidth: maxImageSize,
      maxHeight: maxImageSize,
      mimeType: 'image/jpeg',
      success: async (result: File): Promise<void> => {
        const processedFile = await processFileBlob(result);
        resolve(processedFile.base64);
      },
    });
  });
export default compressImage;
